import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-con4',
  templateUrl: './e-con4.component.html',
  styleUrls: ['./e-con4.component.css']
})
export class ECon4Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
